import React, { FC } from 'react';
import { AttentionWarningImage } from 'src/common/images/AttentionWarningImage';
import { ConfirmationDialog } from 'src/common/components/ConfirmationDialog';
import styled, { css } from 'styled-components';
import { media } from 'src/config/breakpoints';
import { DashUnorderedList } from 'src/common/components/List';
import { useDisenrollFromEventMutator } from 'src/common/hooks/event/useDisenrollFromEventMutator';
import { CourseEvent } from 'src/common/models/event';
import { useDispatch } from 'react-redux';
import { snackbarActions } from 'src/state/notification/notificationActions';

export interface CourseEventDisenrollmentConfirmationDialogProps {
  event: CourseEvent;
  onClose: () => void;
  courseTitle: string;
}

const Content = styled.div`
  ${media.w.max.px992(css`
    display: flex;
    flex-direction: column;
    align-items: center;
  `)}
`;

const TextContainer = styled.div`
  margin-bottom: 0.625rem;
  ${media.w.max.px992(css`
    text-align: center;
  `)};
`;

const StyledDashUnorderedList = styled(DashUnorderedList)`
  width: fit-content;
`;

export const CourseEventDisenrollmentConfirmationDialog: FC<
  CourseEventDisenrollmentConfirmationDialogProps
> = ({ event, courseTitle, onClose }) => {
  const mutation = useDisenrollFromEventMutator();
  const dispatch = useDispatch();

  return (
    <ConfirmationDialog
      title="Uwaga! Odwołujesz swój udział w szkoleniu"
      question="Czy na pewno chcesz zrezygnować z udziału w szkoleniu?"
      image={<AttentionWarningImage />}
      confirmLabel="Tak, rezygnuję z udziału"
      onConfirm={() =>
        mutation
          .mutateAsync({
            eventId: event.id,
            courseId: event.courseId,
          })
          .then(() => {
            dispatch(
              snackbarActions.enqueueSnackbar({
                message: 'Twój udział w szkoleniu został odwołany',
                options: { variant: 'success' },
              }),
            );
            onClose();
          })
      }
      confirmLoading={mutation.isLoading}
      cancelLabel="Nie rezygnuj"
      onCancel={onClose}
    >
      <Content>
        <TextContainer>
          Rezygnując ze szkolenia &quot;{courseTitle}&quot;, utracisz możliwość:
        </TextContainer>
        <StyledDashUnorderedList>
          <li>Konsultacji swoich wyzwań biznesowych</li>
          <li>Otrzymania materiałów pomocniczych</li>
          <li>Odbioru certyfikatu</li>
        </StyledDashUnorderedList>
      </Content>
    </ConfirmationDialog>
  );
};
